export const PASSWORD = "eoamc-website";
